var inputValueReducerGen = function inputValueReducerGen(args) {
  var momentUtils = args.momentUtils,
    dateCalculator = args.dateCalculator;
  return function (state, action) {
    var _action$payload = action.payload,
      payload = _action$payload === void 0 ? {} : _action$payload;
    var value = payload.value;
    switch (action.type) {
      case 'setInputValueByString':
        return {
          inputValue: value
        };
      case 'setInputValueByDate':
        if (value === null) {
          return {
            inputValue: state.inputValue
          };
        } else if (value === undefined) {
          return {
            inputValue: ''
          };
        } else {
          if (value instanceof Array) {
            if (value.length === 0) {
              return {
                inputValue: ''
              };
            } else if (value.length === 1) {
              return {
                inputValue: dateCalculator.calculateDatestringFromDateValues(value[0])
              };
            } else if (value.length === 2) {
              return {
                inputValue: dateCalculator.calculateDatestringFromDateValues(value[0], value[1], true)
              };
            }
          } else {
            return {
              inputValue: momentUtils.format(value)
            };
          }
        }
      default:
        return {
          inputValue: state.inputValue
        };
    }
  };
};
export default inputValueReducerGen;